import { render, staticRenderFns } from "./AssessmentGroupScoreDisplay.vue?vue&type=template&id=67fe4082&scoped=true"
import script from "./AssessmentGroupScoreDisplay.vue?vue&type=script&lang=js"
export * from "./AssessmentGroupScoreDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fe4082",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VForm,VSwitch,VTextField})
